import '@/App.css';
import './lib/areaColors';  // applica al boot eventuali override colori aree
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import Dashboard from './components/Dashboard';
import SetupChat from './components/SetupChat';
import MonthlyPlanChat from './components/MonthlyPlanChat';
import QuarterlyPlanChat from './components/QuarterlyPlanChat';
import WeeklyReviewChat from './components/WeeklyReviewChat';
import WeeklyPlanChat from './components/WeeklyPlanChat';
import Stampa from './components/Stampa';
import Login from './components/Login';
import PaginaObiettivo from './components/PaginaObiettivo';
import PaginaPeriodo from './components/PaginaPeriodo';
import PaginaCalendario from './components/PaginaCalendario';
import PaginaLegenda from './components/PaginaLegenda';
import PaginaTimeline from './components/PaginaTimeline';
import PaginaHeatmap from './components/PaginaHeatmap';
import PaginaRecap from './components/PaginaRecap';
import PaginaStats from './components/PaginaStats';
import PaginaCoachHistory from './components/PaginaCoachHistory';
import PaginaConsumiAI from './components/PaginaConsumiAI';
import VistaOggi from './components/VistaOggi';
import AppLayout from './components/nav/AppLayout';
import { Toaster } from './components/ui/sonner';

function Protected({ children }) {
  const { session, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center">
        <div className="mono-label">Verifico sessione…</div>
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { session, loading } = useAuth();
  if (loading) return null;
  if (session) return <Navigate to="/" replace />;
  return children;
}

/**
 * AppRouter: tutte le route applicative (Native Supabase Auth, niente
 * fragment OAuth Emergent da intercettare).
 */
function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/" element={<Protected><AppLayout><Dashboard /></AppLayout></Protected>} />
      <Route path="/setup" element={<Protected><AppLayout><SetupChat /></AppLayout></Protected>} />
      <Route path="/mese" element={<Protected><AppLayout><MonthlyPlanChat /></AppLayout></Protected>} />
      <Route path="/trimestre" element={<Protected><AppLayout><QuarterlyPlanChat /></AppLayout></Protected>} />
      <Route path="/settimana" element={<Protected><AppLayout><WeeklyReviewChat /></AppLayout></Protected>} />
      <Route path="/pianifica-settimana" element={<Protected><AppLayout><WeeklyPlanChat /></AppLayout></Protected>} />
      <Route path="/stampa" element={<Protected><Stampa /></Protected>} />
      <Route path="/oggi" element={<Protected><AppLayout><VistaOggi /></AppLayout></Protected>} />
      <Route path="/timeline" element={<Protected><AppLayout><PaginaTimeline /></AppLayout></Protected>} />
      <Route path="/calendario" element={<Protected><AppLayout><PaginaCalendario /></AppLayout></Protected>} />
      <Route path="/heatmap" element={<Protected><AppLayout><PaginaHeatmap /></AppLayout></Protected>} />
      <Route path="/recap/:year" element={<Protected><AppLayout><PaginaRecap /></AppLayout></Protected>} />
      <Route path="/stats" element={<Protected><AppLayout><PaginaStats /></AppLayout></Protected>} />
      <Route path="/coach-history" element={<Protected><AppLayout><PaginaCoachHistory /></AppLayout></Protected>} />
      <Route path="/coach-history/:id" element={<Protected><AppLayout><PaginaCoachHistory /></AppLayout></Protected>} />
      <Route path="/consumi-ai" element={<Protected><AppLayout><PaginaConsumiAI /></AppLayout></Protected>} />
      <Route path="/legenda" element={<Protected><AppLayout><PaginaLegenda /></AppLayout></Protected>} />
      <Route path="/obiettivo/:id" element={<Protected><AppLayout><PaginaObiettivo /></AppLayout></Protected>} />
      <Route path="/periodo/:gran/:label" element={<Protected><AppLayout><PaginaPeriodo /></AppLayout></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
